<template>
        <b-container fluid="sm">
            <div>
                <b-row>
                    <b-col>
                        <b-card
                            title="Archivo de diagnostico de riesgos"
                            tag="article"
                            style="max-width: 100%;"
                            class="mb-2"
                            >
                            <div class="card-text">
                                <b-form-file
                                    v-model="riskDiagnosis.file"
                                    :state="Boolean(riskDiagnosis.file)"
                                    placeholder="Seleccione el archivo de análisis de seguridad"
                                    ref="fileinput"
                                ></b-form-file>
                                <div v-if="riskDiagnosis.file" class="mt-3">
                                    Archivo seleccionado:
                                    {{ riskDiagnosis.file && riskDiagnosis.file.name }}
                                </div>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
                <b-col cols="12" class="mt-2">
                    <label for="fileDescription">observaciones sobre el/los archivo(s)</label>
                    <app-form-textarea-input rows="6" id="fileDescription" v-model="riskDiagnosis.notes"></app-form-textarea-input>
                </b-col>
            </div>
        </b-container>
</template>
<script>
export default {
    props: {
        currentClient: {
            type: [Object, Array]
        },
    },
    data: () => ({
        riskDiagnosis: {
            file: null,
            notes: ''
        }
    }),
    methods: {
        async saveRiskDiagnosis() {
                if (!this.riskDiagnosis.file) {
                    return toastr.info('Seleccione el archivo previamente')
                } 
                const formData = new FormData()

                formData.append('clientId', this.currentClient.id)
                formData.append('reportedById', this.user.id)
                formData.append('file', this.riskDiagnosis.file)
                formData.append('notes', this.riskDiagnosis.notes)


                const { data } = await repo.post('risk-diagnosis',formData)
                if (data.status) {
                    this.reset()
                    this.$emit('success',data)
                } else {
                    toastr.error(data.msg)
                }
        },
        reset() {
            this.riskDiagnosis.file = null
            this.riskDiagnosis.notes = ''
        },
    },
}
</script>
